import { isNotNil } from "../../lib/functional";
import { findBreakpointOverride } from "../../breakpoints";
function mergeStyles(source, override, breakpoints) {
  const getDeviceId = ({ deviceId }) => deviceId;
  const devices = [
    .../* @__PURE__ */ new Set([...source.map(getDeviceId), ...override.map(getDeviceId)])
  ];
  return devices.map((deviceId) => {
    const deviceSource = findBreakpointOverride(
      breakpoints,
      source,
      deviceId
    )?.value;
    const deviceOverride = findBreakpointOverride(
      breakpoints,
      override,
      deviceId,
      (v) => v
    )?.value;
    if (deviceSource && deviceOverride) {
      return {
        deviceId,
        value: { ...deviceSource, ...deviceOverride }
      };
    }
    if (deviceOverride) {
      return {
        deviceId,
        value: deviceOverride
      };
    }
    if (deviceSource) {
      return {
        deviceId,
        value: deviceSource
      };
    }
    return null;
  }).filter(isNotNil);
}
export {
  mergeStyles
};
//# sourceMappingURL=style.js.map